import { Modal, Button, Form } from "react-bootstrap";
import styles from '../pa_checklist.module.scss';
import { usePAChecklist } from "../pa_checklist_context";
import Tabela from "../../../Misc/Tabela/Tabela";
import { useEffect, useState } from "react";

const PARevisaoModalProcessamento = () => {
  const { modalProcessamento, setModalProcessamento, quantidadeTotalDirecionada, processarChecklistAnalise, referenciaSelecionada, defeitosTag, gradeRomaneio, precoTagDivergente, composicaoTagDivergente, direcionamentoChecklist, resultadoCaixa } = usePAChecklist();

  const [qtdePecasAmostra] = useState(gradeRomaneio.reduce((sum, item) => sum + (item.quantidade_total || 0), 0));

  const direcionamento_columns = [
    { name: 'Tamanho', selector: row => row.grade.tamanho, width: '100px' },
    { name: 'Quantidade', selector: row => row.quantidade, width: '100px' },
    { name: 'Status', selector: row => row.status_defeito.label, width: '160px' },
    { name: 'Defeitos', selector: row => row.defeitos.map(item => item.label).join(' | ') },
    { name: 'Loc. Defeito', selector: row => row.localizacao_defeito.map(item => item.label).join(' | ') },
    {
      name: 'Direcionamento',
      selector: row => {
        return resultadoCaixa.length > 0 ? '41 - CHECKLIST + DEVOLUÇÃO' : row.direcionamento.label
      }
    }
  ];

  return (
    <Modal
      show={modalProcessamento}
      centered
      size={'lg'}
      onHide={() => setModalProcessamento(false)}
      backdropClassName={styles.backdrop_z_override}
    >
      <Modal.Header style={{ fontWeight: '500' }} closeButton>
        Resumo da Análise | NF: {referenciaSelecionada.nf_entrada} | Produto: {referenciaSelecionada.produto} | Cor: {referenciaSelecionada.cor_produto}
      </Modal.Header>
      <Modal.Body className={styles.modal_body} style={{ fontWeight: '500' }}>
        <div className={styles.resumo_row}>
          <section className={styles.dados_analise_wrapper}>
            <div className={styles.dados_analise_item_duplo}>
              <div>
                <label className={styles.sub_form_label}>Quantidade de peças no romaneio</label>
                <span className={styles.font_blue_big}>{qtdePecasAmostra}</span>
              </div>
              <div>
                <label className={styles.sub_form_label}>Quantidade total de peças direcionadas</label>
                <span className={styles.font_blue_big}>{quantidadeTotalDirecionada}</span>
              </div>
            </div>

            <div
              style={{
                display: referenciaSelecionada.nf_segunda_qualidade || referenciaSelecionada.produto_de_couro ? 'block' : 'none'
              }}
              className={styles.dados_analise_item}
            >
              <label
                style={{ display: referenciaSelecionada.nf_segunda_qualidade ? 'block' : 'none' }}
                className={styles.sub_form_label}
              >
                Esta é uma nota fiscal de segunda qualidade - Portanto todas as peças deverão ser revisadas
              </label>
              <label
                style={{ display: referenciaSelecionada.produto_de_couro ? 'block' : 'none' }}
                className={styles.sub_form_label}
              >
                Esta é uma nota fiscal de couro - Portanto todas as peças deverão ser revisadas
              </label>
            </div>

            <div
              className={styles.separator}
              style={{ display: precoTagDivergente.key || composicaoTagDivergente.key ? 'block' : 'none' }}
            >
            </div>

            <div
              className={styles.direcionamento_info_warn}
              style={{ display: precoTagDivergente.key || composicaoTagDivergente.key ? 'block' : 'none' }}
            >
              Você indicou que há divergências entre as informações da TAG e do produto - todos os direcionamentos serão automaticamente alterados para DEVOLUÇÃO durante o processamento.
            </div>
          </section>
        </div>
        <Tabela
          columns={direcionamento_columns}
          data={direcionamentoChecklist}
          pagination={false}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={'success'}
          onClick={processarChecklistAnalise}
          style={{ margin: '0px auto' }}
          className={styles.footer_btn_processamento}
        >
          Processsar Análise
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PARevisaoModalProcessamento;